module.exports = __webpack_public_path__ + "img/image.10572cff.svg";